interface RecipeImageFallbackProps {
    /** Sizing/positioning classes from the call site (height, rounding, etc.). */
    readonly className?: string;
    /** Compact surfaces like grid cards: smaller text, no edit submessage. */
    readonly compact?: boolean;
}

/**
 * Static placeholder for a recipe with no photo. Deliberately *not* a shimmer —
 * shimmer signals "loading", but a missing image never resolves, so a themed,
 * clearly-empty panel reads as intentional instead of stuck. Shared by the
 * detail hero (HeroPageLayout) and the grid cards (RecipeCard2).
 */
export const RecipeImageFallback = ({ className, compact = false }: RecipeImageFallbackProps) => {
    return (
        <div
            role="img"
            aria-label="No recipe image provided"
            className={`flex flex-col items-center justify-center gap-1 bg-default-200 px-4 text-center ${className ?? ""}`}
        >
            <span aria-hidden className="mb-1 font-display text-sm leading-none text-accent-600/40">
                ✦
            </span>
            <p className={`font-serif italic text-default-600 ${compact ? "text-xs" : "text-sm sm:text-base"}`}>
                No recipe image provided
            </p>
            {!compact && <p className="font-serif text-xs text-default-500">Edit this recipe to add one.</p>}
        </div>
    );
};
